import { ICostSummaryItem, IShippingMethod } from '../../CartContext.types';

export const generateShippingCosts = (
    shippingMethod: IShippingMethod
): ICostSummaryItem | undefined => {
    if (shippingMethod.cost > 0) {
        return {
            lineNumber: 0,
            itemName: `Shipping Cost`,
            amount: shippingMethod.cost,
            type: 'cost'
        };
    }
};
